import cookie from 'js-cookie';

// const module = typeof window !== `undefined` ? require("module") : null


export const isBrowser = () => typeof window !== "undefined"


// set in cookie
export const setCookie = (key, value) => {
    if (isBrowser) {
        cookie.set(key, value, {
            expires: 1
        });
    }
};
// remove from cookie
export const removeCookie = key => {
    if (isBrowser) {
        cookie.remove(key, {
            expires: 1
        });
    }
};
// get from cookie such as stored token
// will be useful when we need to make request to server with token
export const getCookie = key => {
    if (isBrowser) {
        return cookie.get(key);
    }
};
// set in localstorage
export const setLocalStorage = (key, value) => {
    if (isBrowser) {
        localStorage.setItem(key, JSON.stringify(value));
    }
};
// remove from localstorage
export const removeLocalStorage = key => {
    if (isBrowser) {
        localStorage.removeItem(key);
    }
};

// authenticate user by passing data to cookie and localstorage during signin
export const authenticate = (response, next) => {
    console.log('AUTHENTICATE HELPER ON SIGNIN RESPONSE', response);
    setCookie('token', response.data.user.token);
    setLocalStorage('user', response.data.user);
    setLocalStorage('bookmarklist', response.data.user.bookmarklist);
    next();
};


// export const getUser = () => {
//     if (isBrowser && window.localStorage.getItem('gatsbyUser') ) {
//         JSON.parse(window.localStorage.getItem('gatsbyUser'))
//     } else {
//         {}
//     }
// }


export const getUser = () =>
    isBrowser() && window.localStorage.getItem("user")
        ? JSON.parse(window.localStorage.getItem("user"))
        : {}

export const getBookMarkList = () =>
    isBrowser() && window.localStorage.getItem("bookmarklist")
        ? JSON.parse(window.localStorage.getItem("bookmarklist"))
        : []

// access user info from localstorage
export const isAuth = () => {
    if (isBrowser) {
        const cookieChecked = getCookie('token');
        if (cookieChecked) {
            if (localStorage.getItem('user')) {
                return JSON.parse(localStorage.getItem('user'));
            } else {
                return false;
            }
        }
    }
};

export const signout = next => {
    removeCookie('token');
    removeLocalStorage('user');
    removeLocalStorage('bookmarklist');
    next();
};

export const updateUser = (response, next) => {
    console.log('UPDATE USER IN LOCALSTORAGE HELPERS', response);
    if (typeof isBrowser) {
        let auth = JSON.parse(localStorage.getItem('user'));
        auth = response.data;
        localStorage.setItem('user', JSON.stringify(auth));
    }
    next();
};


export const updateBookMarkList = (response) => {
    removeLocalStorage('bookmarklist'); //alert();
    setLocalStorage('bookmarklist', response.data.bookmarklist); 
};